<template>
  <v-chip v-if="formattedValue > 100 && offerType === 'nextbuycashback'" small :style="color" style="width: 82.14px; justify-content: center">
    <tooltip message="Esse valor é maior que 100% pois é possível que 1 único cupom gere mais de 1 cashback">
      {{ formattedValue }}%
      <mf-icon small color="#27a125">info</mf-icon>
    </tooltip>
  </v-chip>
  <v-chip v-else small :style="color" style="width: 63.83px; justify-content: center">{{ formattedValue }}%</v-chip>
</template>

<script>
export default {
  name: 'PercentColorChip',
  components: {
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    value: Number,
    highestValue: Number,
    offerType: {
      type: String,
      validator: (value) =>
        [
          'general',
          'percentage',
          'takepay',
          'combo',
          'cashback_percentage',
          'cashback_absolute',
          'points',
          'nextbuycashback',
          'dynamic_rule',
          'crosssell',
        ].includes(value),
    },
  },
  computed: {
    color() {
      const comparisonValue = this.highestValue / 3
      let tagColor = '#fff'
      if (this.value < comparisonValue) {
        tagColor = '#F1D1A1'
      } else if (this.value >= comparisonValue && this.value < comparisonValue * 2) {
        tagColor = '#DBE287'
      } else if (this.value >= comparisonValue * 2) {
        tagColor = '#79DB77'
      }
      return `background-color: ${tagColor} !important; color: #31363B !important;`
    },

    formattedValue() {
      return Number.isInteger(this.value) ? this.value : parseFloat(this.value).toFixed(2)
    },
  },
}
</script>
